<template>
  <div id="contenedor-auditorias-main">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'AuditoriasMain',
  data() {
    return {};
  },
};
</script>
